/*
 * File: utils
 * File Created: 2021-05-12 11:23:23 am
 * Author: huangxl (huangxl20@meicloud.com)
 * -----
 * Last Modified: 2021-06-09 3:10:43 pm
 * Modified By: huangxl (huangxl20@meicloud.com)
 */

import device from 'mds-libs/libs/common/utils/device/src/index.js'
import Config from '../config'

/**
 * 是否为PC端
 * @returns {Boolean}
 */
function isPC() {
  var userAgentInfo = navigator.userAgent;
  var Agents = ["Android", "iPhone",
              "SymbianOS", "Windows Phone",
              "iPad", "iPod", "MideaOpenHormanyNext", "Phone", "OpenHarmony 5.0"];
  var flag = true;
  for (var v = 0; v < Agents.length; v++) {
      if (userAgentInfo.indexOf(Agents[v]) > 0) {
          flag = false;
          break;
      }
  }
  return flag;
}

/**
 * 是否为安卓端
 * @returns {Boolean}
 */
function IsAndroid() {
  var u = navigator.userAgent;
  if (u.indexOf('Android') > -1 || u.indexOf('Adr') > -1) {
      return true
  } else {
      return false
  }
}

/**
 * 是否为windows系统
 * @returns {Boolean}
 */
function isWindows() {
  let ua = navigator.userAgent
  return /Windows/i.test(ua)
}

/**
 * 是否为Mac系统
 * @returns {Boolean}
 */

function isMac() {
  let ua = navigator.userAgent
  return /Mac OS X/i.test(ua)
}

/**
 * 是否为平板
 */
function isTablet() {
  let ua = navigator.userAgent
  return /(?:iPad|PlayBook)/.test(ua) || (device.isAndroid() && !/(?:Mobile)/.test(ua))
}

/**
 * 是否在微信打开
 */
function isWechat() {
  var ua = navigator.userAgent.toLowerCase();//获取判断用的对象
  if (ua.match(/MicroMessenger/i) == "micromessenger") {
    return true
  }
  return false
}
/**
 * 是否在safary打开
 */
function isSafary() {
  if (/Safari/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent)) {
    return true
  }
  return false
}

// 是否在鸿蒙Next打开
function isHarmonyOS(){
  return (navigator.userAgent.indexOf('MideaOpenHormanyNext') !== -1 || navigator.userAgent.indexOf('OpenHarmony 5.0') !== -1)
}

/**
 * 是否美信内部环境
 */
 function isMX() {
  var ua = navigator.userAgent.toLowerCase();//获取判断用的对象
  console.log('1', navigator.userAgent)
  console.log('2', navigator.userAgent.toLowerCase())
  console.log('3', ua.match(/mideaconnect/i))
  console.log('4', ua.match(/mideaconnect/i) == 'mideaconnect')
  if (ua.match(/mideaconnect/i) == "mideaconnect") {
    return true
  }
  return false
}

function queryURLParams(url) {
  let pattern = /(\w+)=(\w+)/ig; //定义正则表达式
  let parames = {}; // 定义参数对象
  url.replace(pattern, ($, $1, $2) => {
    parames[$1] = $2;
  });
  return parames;
}

/**
 * 获取美信客户端scheme
 */
function getMissionScheme() {
  if (isPC()) {
    const pcSchemeMap = {
      dev: 'meicloudsit',
      sit: 'meicloudsit',
      uat: 'meiclouduat',
      prod: 'meicloud'
    }
    return pcSchemeMap[process.env.MDS_APP_ENV]
  } else if(IsAndroid()) {
    // 安卓
    const mobileSchemeMap = {
      dev: 'missiontest',
      sit: 'missiontest',
      uat: 'mideaconnectuat',
      prod: 'mideaconnect'
    }
    return mobileSchemeMap[process.env.MDS_APP_ENV]
  } else if(isHarmonyOS()){
    // 鸿蒙
    const mobileSchemeMap = {
      dev: 'missiontest',
      sit: 'missiontest',
      uat: 'missionuat',
      prod: 'mideaconnect'
    }
    return mobileSchemeMap[process.env.MDS_APP_ENV]
  } else {
    // IOS
    const mobileSchemeMap = {
      dev: 'missiontest',
      sit: 'missiontest',
      uat: 'missiontest',
      prod: 'mideaconnect'
    }
    return mobileSchemeMap[process.env.MDS_APP_ENV]
  }
}
/**
 * 获取腾讯会议客户端scheme
 */
function getMissionSchemeForWX() {
  // if (isPC()) {
  //   const pcSchemeMap = {
  //     dev: 'meicloudsit',
  //     sit: 'meicloudsit',
  //     uat: 'meiclouduat',
  //     prod: 'meicloud'
  //   }
  //   return pcSchemeMap[process.env.MDS_APP_ENV]
  // } else {
  //   const mobileSchemeMap = {
  //     dev: 'missiontest',
  //     sit: 'missiontest',
  //     uat: 'mideaconnectuat',
  //     prod: 'mideaconnect'
  //   }
  //   return mobileSchemeMap[process.env.MDS_APP_ENV]
  // }
  return 'wemeet'
}

/**
 * 生成打开美信客户端的scheme地址
 * @param {String} meetingUuid 会议uuid
 * @param {Number} secure 是否高安会议
 * @param {Number} resource 会议表示 0：默认zoom标识尚阳会议 1：TM表示腾讯会议
 * @return {String} 美信 scheme 地址
 */
function genrateMissionOpenUrl(meetingUuid, secure, resource) {
  console.log('传入的标识：resource：', resource)
  if(resource == 1) {
    return `${ getMissionScheme() }://meeting?meetingUuid=${ meetingUuid }&meetingType=${ secure }&resource=${ resource }`
  }else {
    return `${ getMissionScheme() }://umeeting?meetingUuid=${ meetingUuid }&meetingType=${ secure }&resource=${ resource }`
  }
}

/**
 * 生成打开腾讯会议客户端的scheme地址
 * @param {String} meetingCode 会议code
 * @param {Number} secure 是否高安会议
 * @param {Number} resource 会议表示 0：默认zoom标识尚阳会议 1：TM表示腾讯会议
 * @return {String} 美信 scheme 地址
 */
function genrateMissionOpenWXUrl(meetingUuid) {
  console.log('传入的标识：resource：')
  return `${ getMissionSchemeForWX() }://page/inmeeting?meeting_code=${ meetingUuid }`
}

/**
 * 获取美的会议客户端的scheme
 */
function getMideaMeetingScheme() {
  return 'mideameetingapp'
}

/**
 * 生成打开美的会议客户端的scheme地址
 * @param {*} meetingUuid 会议uuid
 * @param {*} secure 是否高安会议
 * @returns {String} 美的会议 scheme 地址
 */
function genrateMideaMeetingOpenUrl(umeetUuid, meetingNumber) {
  return `${ getMideaMeetingScheme() }://join?meetingId=${ umeetUuid }&meetingNumber=${ meetingNumber }&displayName=&password=&userId`
}

// 获取下载美信地址
function getMissionDownloadUrl() {
  if (process.env.MDS_APP_ENV !== 'prod') {
    return 'https://mapnew5sit.midea.com/appdownload/pcv5.html'
  } else {
    return 'https://im.midea.com/download/pcv5.html'
  }
}

// 获取下载MideaMeeting地址
function getMideaMeetingDownloadUrl() {
  if (process.env.MDS_APP_ENV !== 'prod') {
    return 'https://mapnew5sit.midea.com/appdownload/pcv5.html'
  } else {
    return 'https://im.midea.com/download/mideameeting/mideameetingPc.html'
  }
}
// 获取下载腾讯会议地址
function getTXMeetingDownloadUrl(locale) {
  if(locale === 'zh-CN') {
    return Config.toDownloadTXMeeting
  } else {
    return Config.toDownloadVooV
  }
}

export {
  isPC,
  isWindows,
  isMac,
  isTablet,
  isSafary,
  isWechat,
  isMX,
  queryURLParams,
  getMissionDownloadUrl,
  getMideaMeetingDownloadUrl,
  genrateMissionOpenUrl,
  genrateMissionOpenWXUrl,
  genrateMideaMeetingOpenUrl,
  getTXMeetingDownloadUrl
}
